module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../node_modules/babel-runtime/core-js/object/get-prototype-of.js
// module id = 114
// module chunks = 0